import PropTypes from "prop-types";
import "./progressBar.scss";

const ProgressBar = ({ label, subLabel, start, end, value }) => {
  return (
    <div className="progress-bar">
      {!!label && <div className="progress-bar-label">{label}</div>}
      <div className="progress-bar-content">
        {!!start === false && (
          <div className="progress-bar-content_start">{start}%</div>
        )}
        <div className="progress-bar-content_bg">
          <div
            className="progress-bar-content_bar"
            style={{ width: `${(value / (end - start)) * 100}%` }}
          />
        </div>
        {!!end && <div className="progress-bar-content_end">{end}%</div>}
      </div>
      {!!subLabel && <div className="progress-bar-label_sub">{subLabel}</div>}
    </div>
  );
};

ProgressBar.propTypes = {
  label: PropTypes.string,
  subLabel: PropTypes.string,
  start: PropTypes.number,
  end: PropTypes.number,
  value: PropTypes.number.isRequired,
};

export default ProgressBar;
